import { DbListBase } from './db-list-base';
import { IDatabase } from '../database-cast/IDatabase';

export class DbRecycles extends DbListBase<any> {

    constructor(database: IDatabase) {
        super(database.collection(`recycles`));
   
    }

  
}
